import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import gql from 'graphql-tag';
export const getTasksCommentQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getTasksComment($id: Int) {\n    taskComments(id: $id) {\n      id\n      text\n      createdAt\n      createdBy\n    }\n  }\n"])));
export const getTasksCommentQueryOptions = id => ({
  variables: {
    id
  },
  fetchPolicy: 'no-cache',
  notifyOnNetworkStatusChange: true
});
export const getAllTasksCommentQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nquery getAllTasksComments {\n  allTaskComments {\n    id\n    text\n    createdAt\n    createdBy\n    taskID\n  }\n}\n"])));